import { Body1, Button, UIHeading1 } from '@cian/ui-kit';
import * as React from 'react';
import { NBSP } from 'shared/constants/symbols';

import * as styles from './styles.css';

export interface IMortgageRateHikeBannerProps {
  onButtonClick: () => void;
}

export const MortgageRateHikeBanner: React.FC<IMortgageRateHikeBannerProps> = ({ onButtonClick }) => {
  return (
    <div className={styles['container']} data-testid="MortgageRateHikeBanner">
      <div className={styles['content']}>
        <div className={styles['text-group']}>
          <UIHeading1 color="text-inverted-default">Семейные квартиры на{NBSP}прежних условиях</UIHeading1>
          <Body1 color="text-inverted-default">
            До{NBSP}1{NBSP}октября есть время
          </Body1>
        </div>

        <Button
          data-testid="MortgageRateHikeBannerButton"
          size="M"
          theme="inverted"
          type="button"
          onClick={onButtonClick}
        >
          Буду знать
        </Button>
      </div>

      <div aria-hidden={true} className={styles['image-slot']} />
    </div>
  );
};
